import styled from 'styled-components'
import { brandPalette as palette } from '../../styles/abstracts/_variables.styles'

export const TidePanel = styled.details`
  scroll-margin-top:10rem; margin:0 0 2rem; background:${palette.chalk}; border:1px solid var(--forecast-line); border-radius:.6rem;
  >summary{cursor:pointer;padding:1.3rem 2rem;min-height:5.2rem;display:list-item;list-style-position:inside;font-size:1.6rem;}
  >summary span{font-weight:600;} >summary small{font-size:1.3rem;margin-left:1.4rem;white-space:nowrap;}
  .tide-content{padding:0 2rem 1.6rem;} .tide-content>p { font-size:1.4rem; max-width:85ch; }
  .tide-chart { margin-top:1rem; }
  svg { display:block; width:100%; height:auto; max-height:22rem; font-family:'AvenirNextLTPro-Regular',sans-serif; }
  svg text { fill:${palette.ink}; font-size:12px; }
  details { border-top:1px solid var(--forecast-line); margin-top:1.4rem; padding-top:.3rem; font-size:1.4rem; }
  details summary { cursor:pointer; min-height:4.4rem; display:flex; align-items:center; text-decoration:underline; text-underline-offset:.3rem; }
  details p { max-width:88ch; }
  @media(max-width:767px){>summary{padding:1.2rem 1.5rem;} .tide-content{padding:0 1.5rem 1.4rem;}}
  @media(max-width:479px){scroll-margin-top:8rem;>summary{font-size:1.5rem;} >summary small{display:block;margin:.5rem 0 0 1.7rem;}}
`
export const TideEvents = styled.dl`
  display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:1.2rem; margin:1.6rem 0 1rem;
  >div { padding:1.3rem; background:${palette.limestone}; border-radius:.4rem; }
  dt { font-size:1.35rem; margin-bottom:.4rem; } dd{margin:0;font-size:1.5rem;} strong{display:block;font-size:1.7rem;} span{display:block;font-variant-numeric:tabular-nums;}
  @media(max-width:767px){grid-template-columns:repeat(2,minmax(0,1fr));}
  @media(max-width:359px){grid-template-columns:1fr;}
`
